const LG_HIGHER_VERSIONS = 4;
const WEB_OS_5_VERSION = 5;

export function isLowEndLG() {
  if (localStorage.lgSdkVersion) {
    if (parseInt(localStorage.lgSdkVersion) < LG_HIGHER_VERSIONS) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export function isHighEndLG() {
  if (window.location.href.includes("localhost")) {
    return true;
  } else if (localStorage.lgSdkVersion) {
    if (parseInt(localStorage.lgSdkVersion) >= WEB_OS_5_VERSION) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export function isLowEndLGFromWebOS5() {
  if (localStorage.lgSdkVersion) {
    if (parseInt(localStorage.lgSdkVersion) <= WEB_OS_5_VERSION) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
